import { Loadable } from '../../../common';

export const Page = Loadable(() => import('./Page'));
